module.exports = __webpack_public_path__ + "static/media/LV4@3x.3617ef02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV4@3x.png
// module id = 684
// module chunks = 0